import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
// services
import { AuthService } from 'src/app/shared/services/auth.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  constructor(private authService: AuthService, private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const isLoggedIn = this.authService.isAuthenticated();

    // const allowedRoles = route.data['allowedRoles'];
    // const userRole = this.authService.getRole();

    if (isLoggedIn) return true;

    // if(isLoggedIn) return this.router.navigateByUrl('/menu/list');

    return this.router.navigateByUrl('auth/login');
  }
}
